import React,{Component} from 'react';
function EventClick(){
    function HandleClick(){
        console.log("Click Handlede");
    }
    return (
        <div style={{marginLeft :"100px"}}> 
            <button onClick={HandleClick} >Click Me To Handle </button>
            <button onClick={HandleClick()} >Event is already Fired </button><br/><br/>
             How The Event Work In class Component (class component Event)<br/><br/><br/>
             <EventHandlinginClassComponent></EventHandlinginClassComponent>
        </div>
    )
}
class EventHandlinginClassComponent extends Component {
    HandleClick(){
        console.log('Hello From Class Event')
    }
    render() {
        return (
            <> 
            <button onClick={this.HandleClick} >Click Me To Handle From Class  </button>
            {/* <button onClick={HandleClick()} >Event is already Fired </button> */}
            <br/>  <br/>  <br/>
            <EvenBind></EvenBind>
             </>
        )
    }
}
class EvenBind extends Component{
    constructor(props) {
        super(props)
    
        this.state = {
                Message:"Login",
                AdminPane:"AdminPanel",
                LoginUser:"Ravindrapatel",
                Display:false
        }
        this.HandleClickthreee = this.HandleClickthreee.bind(this)
    }
    HandleClick(){
        this.setState((prevState) => ({
            Display:(prevState.Display) ? false : true,
            Message:(prevState.Message === "Login") ? "Logout" : "Login"
        }))
    }
    HandleClicktwo(){
        this.setState((prevState) => ({
            AdminPane:(prevState.AdminPane === "AdminPanel") ? "UserPanel" : "AdminPanel"
        }))
    }
    HandleClickFour= () => {
        this.setState((prevState) => ({
            AdminPane:(prevState.AdminPane === "AdminPanel") ? "UserPanel" : "AdminPanel"
        }))
    }
    HandleClickthreee(){
        this.setState((prevState) => ({
            Display:(prevState.Display) ? false : true,
            Message:(prevState.Message === "Login") ? "Logout" : "Login"
        }))
    }
    render() {
        return (
            <> 
            {  (this.state.Display === true) ? <h1> {this.state.LoginUser}</h1> : null}
            <button onClick={this.HandleClick.bind(this)} >{this.state.Message} </button>&nbsp;&nbsp;&nbsp;
            <button onClick={() => this.HandleClicktwo()} >{this.state.AdminPane} </button>&nbsp;&nbsp;&nbsp;
            {  (this.state.Display === true)? <button onClick={this.HandleClickthreee} >LogoutCurrent User </button> : null }&nbsp;&nbsp;&nbsp;
            <button onClick={this.HandleClickFour} >{this.state.AdminPane} </button>&nbsp;&nbsp;&nbsp;
            {/* <button onClick={HandleClick()} >Event is already Fired </button> */}            
             </>
        )
    }
}
class PassMethodFromParntToChild extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
parentName:'Parent'
        }
        this.HandleClickParent=this.HandleClickParent.bind(this)
    }
    HandleClickParent(childName){
        alert(`Hello ${this.state.parentName} from ${childName}`)
    }
    render() {
        return (
            <div style={{marginLeft:"100px",marginTop:"40px"}}>
                <ChildComponent HandleClickFromChild={this.HandleClickParent}></ChildComponent>
            </div>
        )
    }
}

function ChildComponent(props){
    return(
        <div><button onClick={() => props.HandleClickFromChild('child')}>HandlleClick From Child To Parent</button></div>
    )
}


export {EventClick,PassMethodFromParntToChild}